module.exports = __webpack_public_path__ + "img/home-banner.c32ec4f9.svg";